import { useState } from "react";
import { Tabs, Tab, TabList, TabPanels, TabPanel } from "@chakra-ui/react";

export const MyDynoTabsComponent = ({ tabs }) => {
  const [selectedTab, setSelectedTab] = useState(0);

  const handleTabChange = (index) => {
    setSelectedTab(index);
  };

  return (
    <Tabs onChange={handleTabChange} index={selectedTab}>
      <TabList>
        {tabs.map((tab, index) => (
          <Tab key={index} onClick={() => handleTabChange(index)} width="auto">
            {tab.name}
          </Tab>
        ))}
      </TabList>

      <TabPanels>
        {tabs.map((tab, index) => (
          <TabPanel key={index}>{tab.children}</TabPanel>
        ))}
      </TabPanels>
    </Tabs>
  );
};
